import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AlbumsProps } from '@/types/albumsProps'

const initialState: AlbumsProps = {
  albums: [],
}

const albumsSlice = createSlice({
  name: 'albums',
  initialState,
  reducers: {
    handleSetAlbums(state, action: PayloadAction<AlbumsProps>) {
      state.albums = action.payload.albums
    },
  },
})

export const { handleSetAlbums } = albumsSlice.actions
export default albumsSlice.reducer
